export default [
  {
    name: "stocki_index",
    path: "/inv/stock",
    component: () => import("../pages/inv/stock/index.vue"),
  },
  {
    name: "stocki_log",
    path: "/inv/log-stock",
    component: () => import("../pages/inv/stockLog/index.vue"),
  },
  // {
  //   name: "stocki_in",
  //   path: "/inv/stock-in",
  //   component: () => import("../pages/inv/stockIn/index.vue"),
  // },
  {
    name: "stocki_out",
    path: "/inv/stock-out",
    component: () => import("../pages/inv/stockOut/index.vue"),
  },
  {
    name: "transferi_create",
    path: "/inv/transfer-stock",
    component: () => import("../pages/inv/transferStock/index.vue"),
  },
  // {
  //   name: "stocki_in",
  //   path: "/inv/add-product-code",
  //   component: () => import("../pages/inv/addCodeProduct/index.vue"),
  // },

  {
    name: "stockobts_index",
    path: "/inv/stock-obts",
    component: () => import("../pages/union/stock/index.vue"),
  },
  {
    name: "stockobts_log",
    path: "/inv/stock-obts/log",
    component: () => import("../pages/union/stock/logStock.vue"),
  },
  {
    name: "warehouse_index",
    path: "/inv/warehouse",
    component: () => import("../pages/global/warehouse/index.vue"),
  },
  {
    name: "stockopname_index",
    path: "/inv/stockopname",
    component: () => import("../pages/inv/stockOpname/index.vue"),
  },
  {
    name: "stockopname_create",
    path: "/inv/stockopname/create",
    component: () => import("../pages/inv/stockOpname/create.vue"),
  },
  {
    name: "stockopname_detail",
    path: "/inv/stockopname/:id",
    component: () => import("../pages/inv/stockOpname/detail.vue"),
  }
];
